'use es6';

import CustomWidgets from 'reporting-ui-components/components/customWidgets/constants/widgets';
import SecondaryDateRangeEditor from 'reporting-enablement/components/reportEditors/SecondaryDateRangeEditor';
import { getCustomWidgetType } from '../../utils/salesAnalyticsHelpers';
import usageTracker from '../../utils/usageTracker';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const SecondaryDateRangeControl = ({
  context: {
    secondaryDateRange
  },
  updateContext,
  report
}) => /*#__PURE__*/_jsx(SecondaryDateRangeEditor, {
  appUsageTracker: usageTracker,
  report: report.setIn(['displayParams', 'salesAnalytics', 'context', 'secondaryDateRange'], secondaryDateRange),
  onChange: updatedReport => {
    const newDateRange = updatedReport.getIn(['displayParams', 'salesAnalytics', 'context', 'secondaryDateRange']);
    updateContext({
      secondaryDateRange: newDateRange
    }, report);
  }
});
SecondaryDateRangeControl.displayName = 'SecondaryDateRangeControl';
SecondaryDateRangeControl.isUsableForReport = ({
  report,
  subAppKey
}) => [CustomWidgets.WATERFALL, CustomWidgets.CHANGE_HISTORY_DEAL_LIST].includes(getCustomWidgetType(report)) || [SUB_APPS.waterfall, SUB_APPS.changeHistoryDealList].includes(subAppKey);